export default __webpack_public_path__ + "static/media/chapter4.a549fef2.jpg";